export default __webpack_public_path__ + "static/media/1.c24a57d4.png";